import { render, staticRenderFns } from "./MatchResult.vue?vue&type=template&id=8c9d3e58&scoped=true&"
import script from "./MatchResult.vue?vue&type=script&lang=js&"
export * from "./MatchResult.vue?vue&type=script&lang=js&"
import style0 from "./MatchResult.vue?vue&type=style&index=0&id=8c9d3e58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9d3e58",
  null
  
)

export default component.exports